const MAX_NAMES = 5;
const TRACKING = 'so sales are tracked only once they share it (caption edit, story, bio or pinned comment).';

/** Creators who already posted when codes are generated: their published posts can't carry the code. */
export const shopifyLiveCopy = {
  chip: 'Live',
  chipTip: "Already posted. Their published content doesn't include this code.",
  title: 'Some creators are already live',
  confirm: 'Generate anyway',
  cancel: 'Cancel',
  unknownBody: `Discovr couldn't check who's already live. Creators who already posted don't have this code in their published posts, ${TRACKING}`,
  staleNote: "Discovr couldn't confirm the latest, so this list may be out of date.",
  body: (names: string[]): string => {
    const shown = names.slice(0, MAX_NAMES).join(', ');
    const more = names.length - MAX_NAMES;
    const list = more > 0 ? `${shown} and ${more} more` : shown;
    const one = names.length === 1;
    return `${names.length} ${one ? 'creator' : 'creators'} already posted: ${list}. Their published ${one ? 'post doesn' : 'posts don'}'t include this code, ${TRACKING}`;
  },
} as const;
